const captionCls = "gfxc148l26j";
const titleCls = "gfxt14t06wj";
const spanCls = "gfxslucn7q";

export { captionCls, spanCls, titleCls };
import "./Caption.linaria.module.css";
//# sourceMappingURL=Caption.js.map
